export const AgreementType = {
  PERSONAL_DATA: 'PERSONAL_DATA',
  CREDIT_BUREAU: 'CREDIT_BUREAU',
  ELECTRONIC_DOCUMENT_MANAGEMENT: 'ELECTRONIC_DOCUMENT_MANAGEMENT',
  CLIENT_AGREEMENT: 'CLIENT_AGREEMENT',
  PERSONAL_DATA_PROCESSING_POLICY: 'PERSONAL_DATA_PROCESSING_POLICY'
};
